export const ACTIVITY_CARD_STATUS = {
    TODO: 'todo',
    LOCKED: 'locked',
    COMPLETED: 'completed',
    NOT_COMPLETED: 'not_completed',
    EXTRA: 'extra',
} as const;

export type TActivityCardStatus = typeof ACTIVITY_CARD_STATUS[keyof typeof ACTIVITY_CARD_STATUS];

export const MEDICATION_BADGE_STATUS = {
    IN_SLOT: 'in_slot',
    OUT_OF_SLOT: 'out_of_slot',
    NOT_TAKEN: 'not_taken',
    NOT_REGISTERED: 'not_registered',
} as const;

export type TMedicationBadgeStatus = typeof MEDICATION_BADGE_STATUS[keyof typeof MEDICATION_BADGE_STATUS];
